/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { getUproColor } from "utils/colors";
import { formatDate, formatMoneyPunto, makeNiceText } from "utils/formatters";

const getRows = (data, handleClick, valorarItem) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            data={
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color:
                    item?.estado === "ABIERTO"
                      ? getUproColor("uproPink")
                      : item?.estado === "CERRADO"
                      ? getUproColor("uproGreen")
                      : item?.estado === "RESERVADO"
                      ? getUproColor("uproYellow")
                      : item?.estado === "PAGO EN REVISIÓN"
                      ? getUproColor("uproYellow")
                      : item?.estado === "PENDIENTE DE PAGO"
                      ? getUproColor("uproYellow")
                      : item?.estado === "EN PREPARACIÓN"
                      ? getUproColor("uproYellow")
                      : getUproColor("uproBlue"),
                }}
                fontSize="lg"
              >
                {item?.tipo === "Cafetería" ? "local_cafe" : "restaurant_menu"}
              </Icon>
            }
            onClick={() => handleClick(item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={item?.tipo} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color:
                      item?.estado === "ABIERTO"
                        ? getUproColor("uproPink")
                        : item?.estado === "CERRADO"
                        ? getUproColor("uproGreen")
                        : item?.estado === "RESERVADO"
                        ? getUproColor("uproYellow")
                        : item?.estado === "PAGO EN REVISIÓN"
                        ? getUproColor("uproYellow")
                        : item?.estado === "EN PREPARACIÓN"
                        ? getUproColor("uproYellow")
                        : item?.estado === "PENDIENTE DE PAGO"
                        ? getUproColor("uproYellow")
                        : getUproColor("uproBlue"),
                  }}
                  fontSize="lg"
                >
                  {item?.tipo === "Cafetería" ? "local_cafe" : "restaurant_menu"}
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.estado === "RESERVADO" &&
              item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
              item?.venta?.pagos[0]?.estado == "Pendiente" ? (
                <SoftButton
                  color="primary"
                  size="small"
                  circular
                  sx={{ cursor: "pointer", padding: "0.2rem 0.5rem", fontSize: "0.6rem" }}
                  onClick={() => handleClick(item)}
                >
                  <SoftTypography variant="caption" color="white" fontSize="0.6rem">
                    Cargar comprobante
                  </SoftTypography>
                </SoftButton>
              ) : (
                `Nº ${item?.id}`
              )
            }
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {`Nº ${item?.id}`}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              <SoftTypography variant="caption" fontWeight="medium">
                {item?.estado === "RESERVADO" &&
                dayjs(item?.fechaPedido).isBefore(dayjs().startOf("day"))
                  ? "Reserva vencida"
                  : item?.estado === "RESERVADO" &&
                    item?.venta?.pagos[0]?.medioDePago?.nombre != "Transferencia"
                  ? `Reservado para ${
                      dayjs(item?.fechaPedido).isAfter(dayjs().subtract(2, "day"))
                        ? formatDate(item?.fechaPedido, "XXXX")
                        : formatDate(item?.fechaPedido, "dd/MM/yyyy")
                    }`
                  : item?.estado === "RESERVADO" &&
                    item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                    item?.venta?.pagos[0]?.estado == "Pendiente"
                  ? `PENDIENTE DE PAGO`
                  : item?.estado === "RESERVADO" &&
                    item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                    item?.venta?.pagos[0]?.estado == "Revision"
                  ? `PAGO EN REVISION`
                  : item?.estado}
              </SoftTypography>
            }
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              <SoftBadge
                variant="color"
                color={
                  item?.estado === "ABIERTO"
                    ? getUproColor("uproPink")
                    : item?.estado === "CERRADO"
                    ? getUproColor("uproGreen")
                    : item?.estado === "RESERVADO"
                    ? getUproColor("uproYellow")
                    : item?.estado === "PAGO EN REVISIÓN"
                    ? getUproColor("uproYellow")
                    : item?.estado === "PENDIENTE DE PAGO"
                    ? getUproColor("uproYellow")
                    : item?.estado === "EN PREPARACIÓN"
                    ? getUproColor("uproYellow")
                    : getUproColor("uproBlue")
                }
                badgeContent={
                  item?.estado === "PENDIENTE DE PAGO"
                    ? `Vence a las ${
                        // 30 min luego del createdAt
                        dayjs(item?.createdAt).add(30, "minute").format("HH:mm")
                      }`
                    : item?.estado
                }
              />
            </SoftTypography>
          </SoftBox>
        ),
        total: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            data={
              item?.total
                ? `$ ${formatMoneyPunto(item?.total)}`
                : `
            $ ${formatMoneyPunto(
              item?.detalles.reduce((acc, detalle) => acc + detalle.cantidad * detalle.precio, 0)
            )}
            `
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.total
                ? `$ ${formatMoneyPunto(item?.total)}`
                : `
              $ ${formatMoneyPunto(
                item?.detalles.reduce((acc, detalle) => acc + detalle.cantidad * detalle.precio, 0)
              )}
              `}
            </SoftTypography>
            <Tooltip title={item?.total ? "Pagado" : "Pendiente de pago"} placement="top">
              <Icon
                sx={{
                  color: item?.total ? getUproColor("uproGreen") : getUproColor("uproYellow"),
                  cursor: "pointer",
                  ml: 0.5,
                }}
              >
                {item?.total ? "done" : "hourglass_empty"}
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
        turno: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            data={item?.turnoReserva ? item?.turnoReserva : "Sin turno"}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.turnoReserva ? item?.turnoReserva : "Sin turno"}
            </SoftTypography>
          </SoftBox>
        ),
        destino: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            data={item?.destino ? makeNiceText(item?.destino) : "VM"}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.destino ? makeNiceText(item?.destino) : "VM"}
            </SoftTypography>
          </SoftBox>
        ),
        creado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            data={
              dayjs(item?.createdAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.createdAt, "XXXX a las hh:mm")
                : formatDate(item?.createdAt, "dd/MM/yyyy a las hh:mm")
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.createdAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.createdAt, "XXXX a las hh:mm")
                : formatDate(item?.createdAt, "dd/MM/yyyy a las hh:mm")}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox display="flex" justifyContent="center" alignItems="center">
            <SoftButton
              color="uproYellow"
              circular
              onClick={() => {
                valorarItem(item);
              }}
              sx={{ mr: 1 }}
              disabled={item?.valoracion || item.estado !== "CERRADO"}
            >
              <Icon>star</Icon>
              &nbsp; Valorar
            </SoftButton>

            <SoftBox
              sx={{
                cursor: "pointer",
              }}
              onClick={() => handleClick(item)}
            >
              <Tooltip title="Opciones" placement="top">
                <SoftButton color="uproGreen" circular iconOnly>
                  <Icon
                    sx={{ cursor: "pointer", mx: 0.5 }}
                    fontSize="small"
                    onClick={() => handleClick(item)}
                  >
                    arrow_forward
                  </Icon>
                </SoftButton>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "Nº", width: "100px", align: "left" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "total", desc: "Total", align: "left" },
  { name: "creado", desc: "Creado", align: "left" },
  { name: "destino", desc: "Destino", align: "left" },
  { name: "turno", desc: "Turno", align: "left" },
  { name: "accion", desc: " ", align: "left", width: "18%", noOrder: true },
];

export default { columns, getRows };
